var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon20PxOfficeWorkerOutline(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.71738 7.23156C7.94092 7.23156 8.9328 6.2397 8.9328 5.01617C8.9328 3.79264 7.94092 2.80078 6.71738 2.80078C5.49383 2.80078 4.50195 3.79264 4.50195 5.01617C4.50195 6.2397 5.49383 7.23156 6.71738 7.23156Z",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.58486 13.9038L8.17287 17.1997H5.27378L4.71992 12.7689H2.83984V11.1074C2.83984 10.0792 3.24831 9.09306 3.97539 8.366C4.70247 7.63893 5.6886 7.23047 6.71684 7.23047C7.74507 7.23047 8.7312 7.63893 9.45828 8.366C10.0175 8.92522 10.3883 9.6377 10.5296 10.4047",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.334 13.2918C10.334 12.7521 10.7716 12.3145 11.3114 12.3145H16.1984C16.7382 12.3145 17.1757 12.7521 17.1757 13.2918V16.224C17.1757 16.7638 16.7382 17.2013 16.1984 17.2013H11.3114C10.7716 17.2013 10.334 16.7638 10.334 16.224V13.2918Z",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.418 12.3131V11.5921C12.418 10.9803 12.9139 10.4844 13.5257 10.4844H13.9827C14.5944 10.4844 15.0905 10.9803 15.0905 11.5921V12.3131",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon20PxOfficeWorkerOutline);
export default __webpack_public_path__ + "static/media/icon_20px_office-worker_outline.c30b6c9861a5bc7983fb4f1eb2014cc2.svg";
export { ForwardRef as ReactComponent };